<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col cols="12">
          <div slot="header">
            <i class="icon-note"></i>Estados Financieros
            <a
              v-show="!no_visible"
              target="_blank"
              class="pull-right btn btn-sm btn-success text-white"
              style="cursor: pointer"
              @click="print()"
            >
              <i class="fa fa-print" /> Imprimir
            </a>

          </div>
        </b-col>
        <b-col cols="12">
          <b-alert :show="dismissCountDown"
                   dismissible
                   variant="danger"
                   @dismiss-count-down="countDownChanged">
            <span v-html="msj_validacion"></span> Será redirigido al inicio {{dismissCountDown}} segundos...
            <b-progress variant="info"
                        :max="dismissSecs"
                        :value="dismissCountDown"
                        height="4px">
            </b-progress>
          </b-alert>

        </b-col>
        <b-col cols="12" v-if="!no_visible">
          <br>
          <visor-pdf v-show="cargado" :url="urlpdf" />
        </b-col>

      </b-row>
    </b-card>
  </div>

 <!-- <b-card v-else class="text-center">
    <h2 class="text-info negrita">NO SE ENCONTRARON RESULTADOS <br> <b-button variant="link" to="/reportes" class="px-0">Regresar</b-button></h2>
  </b-card> -->
</template>

<script>
import { mapGetters } from "vuex";
import toastr from "toastr";
import VisorPdf from "@/components/VisorPdf";

export default {
  name: "pdf-reporte",
  components: {
    VisorPdf
  },

  data() {
    return {
      dismissSecs: 20,
      dismissCountDown: 0,
      no_visible:false,
      ruta_cancelar: '/',
      msj_validacion:'',
      url: this.$route.params.url,
      anio: parseInt(this.$route.params.anio),
      mes: parseInt(this.$route.params.mes),
      empresa: parseInt(this.$route.params.empresa),
      tipo: parseInt(this.$route.params.tipo),
      aprobados: parseInt(this.$route.params.aprobados),
      concierre:  parseInt(this.$route.params.concierre),
      urlpdf: "",
      nombre_pdf: "",
      cargado: false
    };
  },
  methods: {
    load(){
      if(this.empresa && parseInt(this.empresa) !== parseInt(this.empresaId)){
        this.no_visible = true;
        let empresas =['Aldea Global', 'Aldea Coffee', 'AldeaZON'];
        let empresa_selecionada = empresas[parseInt(this.empresaId) -1];
        let empresa_comprobante = empresas[parseInt(this.empresa) -1];
        this.msj_validacion = `<strong>👀 El reporte a generar pertenece a otra empresa</strong>. Actualmente usted está en la empresa <strong>${empresa_selecionada}</strong> y el reporte de la url ingresada es de la empresa <strong>${empresa_comprobante}</strong>, cambie a esa empresa <strong>(${empresa_comprobante})</strong> y vuelva a intentarlo`;
        this.countDownChanged(20);
        return;
      }
      this.cargarPdf()
    },
    async cargarPdf() {
      toastr["info"]("Generando por favor espere...");
      if (this.anio && this.mes) {
        let url_pdf_api = process.env.VUE_APP_API_REPORTES_URL;
        this.urlpdf = `${url_pdf_api}pdf/reporte?empresa=${this.empresa}&anio=${this.anio}&mes=${this.mes}&tipo=${this.tipo}&aprobados=${this.aprobados}&concierre=${this.concierre}`;
        /*let resp = await axios.get(this.urlpdf);
        let data = resp.data;
        if (data && data.includes("DATOS NO ENCONTRADOS")){
          this.cargado = false;
          return toastr["warning"](
            "No se han encontrado registros en el mes seleccionado"
          );
        }*/
        this.cargado = true;
      }
    },
    async print(){
      try {
        // eslint-disable-next-line no-undef
        const response = await axios.post(this.urlpdf, {},{responseType: 'blob'});
        const url = window.URL.createObjectURL(new Blob([response.data],{type: "application/pdf"}));
        window.open(url);
      } catch(error){
        console.log("aca anda");
        console.log(error);
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if(this.dismissCountDown ===0){
        this.$router.push(this.ruta_cancelar);
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
  },
  mounted() {
    this.load();
  }
};
</script>
<style lang="css"></style>
